'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var preact = require('preact');
var prosemirrorState = require('prosemirror-state');
var index_js = require('../utils/index.js');

const TABLE_SELECTOR = ".ct-table-wrapper";
const findAllTables = dom => {
  const result = [];
  let closestTable = dom.closest(TABLE_SELECTOR);
  let count = 0;

  while (closestTable && count < 10) {
    result.push(closestTable);
    closestTable = closestTable.parentNode.closest(TABLE_SELECTOR);
    count += 1;
  }

  return result;
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".ct-drag-button{z-index:50;position:absolute;text-align:center;line-height:28px;cursor:-webkit-grab;width:30px;height:30px;background:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi41IDBhMS41IDEuNSAwIDEgMSAwIDMgMS41IDEuNSAwIDAgMSAwLTN6bTAgNi41YTEuNSAxLjUgMCAxIDEgMCAzIDEuNSAxLjUgMCAwIDEgMC0zem0tMS41IDhhMS41IDEuNSAwIDEgMSAzIDAgMS41IDEuNSAwIDAgMS0zIDB6TTEuNSAwYTEuNSAxLjUgMCAxIDEgMCAzIDEuNSAxLjUgMCAwIDEgMC0zem0wIDYuNWExLjUgMS41IDAgMSAxIDAgMyAxLjUgMS41IDAgMCAxIDAtM3ptMCA2LjVzLS44MjggMCAwIDBhMS41IDEuNSAwIDEgMSAwIDMgMS41IDEuNSAwIDAgMSAwLTN6IiBmaWxsPSIjQjBCMEIwIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=\") no-repeat 50%}";
styleInject(css);

/** @jsx h */
const BUTTON_WIDTH = 30;
class Button extends preact.Component {
  constructor(props) {
    super(props);
    this.tables = [];

    this.handleScroll = e => {
      this.setState(this.props.getPosition());
    };

    this.state = this.props.getPosition();
  }

  componentDidMount() {
    const {
      dom
    } = this.props;
    this.tables = findAllTables(dom);
    this.tables.forEach(table => {
      table.addEventListener("scroll", this.handleScroll);
    });
  }

  componentWillUnmount() {
    this.tables.forEach(table => {
      table.removeEventListener("scroll", this.handleScroll);
    });
  }

  render() {
    const {
      getPosition,
      onDragStart,
      onClick
    } = this.props;
    const {
      left,
      top
    } = getPosition();
    return preact.h("div", {
      className: "ct-drag-button",
      draggable: true,
      style: {
        left: left - BUTTON_WIDTH,
        top
      },
      onDragStart: onDragStart,
      onClick: onClick
    });
  }

}

const DRAG_BUTTON_SCHEMA_PROPS_NAME = "dragBlock";

const hasButton = node => node.type.schema.nodes[node.type.name].spec[DRAG_BUTTON_SCHEMA_PROPS_NAME];
const getSelection = (doc, from, to) => {
  const node = doc.nodeAt(from);

  if (node.type.name === "code_block") {
    return prosemirrorState.TextSelection.create(doc, from, to);
  }

  return prosemirrorState.NodeSelection.create(doc, from);
};

/** @jsx h */
const {
  os
} = index_js.getSystemInfo();
const dragCopyModifier = /MAC/.test(os.toUpperCase()) ? "altKey" : "ctrlKey";
class View {
  constructor(_editorView) {
    this.$popover = document.createElement("div");
    this.$editor = void 0;

    this.destroy = () => {
      this.$popover.remove();
    };

    this.update = editorView => {
      const {
        selection
      } = editorView.state;

      if (selection instanceof prosemirrorState.NodeSelection) {
        if (hasButton(selection.node)) {
          this.showButton(editorView, selection);
          return;
        }
      }

      if (selection instanceof prosemirrorState.TextSelection) {
        const resolvedPos = selection.$from;
        const nodeMaybe = resolvedPos.doc.nodeAt(selection.from);

        if (nodeMaybe && hasButton(nodeMaybe)) {
          const container = prosemirrorState.NodeSelection.create(resolvedPos.doc, selection.from);
          this.showButton(editorView, container);
          return;
        }

        for (let d = resolvedPos.depth; d >= 0; d--) {
          if (hasButton(resolvedPos.node(d))) {
            const container = prosemirrorState.NodeSelection.create(resolvedPos.doc, resolvedPos.before(d));
            this.showButton(editorView, container);
            return;
          }
        }
      }

      this.hideButton();
    };

    this.handleDragStart = (editorView, from, to) => event => {
      const {
        dispatch,
        state
      } = editorView;
      const dragDOM = editorView.nodeDOM(from);
      const selection = getSelection(state.doc, from, to);
      const slice = selection.content();
      event.dataTransfer.setDragImage(dragDOM, 0, 0);
      editorView.dragging = {
        slice,
        move: !event[dragCopyModifier]
      };
      dispatch(state.tr.setSelection(selection));
    };

    this.handleClick = (editorView, from, to) => () => {
      const {
        dispatch,
        state
      } = editorView;
      const selection = getSelection(state.doc, from, to);
      dispatch(state.tr.setSelection(selection));
      editorView.focus();
    };

    this.$popover.classList.add("ct-drag-button-popover");
    this.$editor = _editorView.dom.parentElement;
    this.$editor.appendChild(this.$popover);
  }

  hideButton() {
    preact.render(null, this.$popover, this.$popover.lastElementChild || undefined);
  }

  showButton(editorView, selection) {
    const {
      from,
      to
    } = selection;
    const dom = editorView.nodeDOM(from);
    const buttonProps = {
      onDragStart: this.handleDragStart(editorView, from, to),
      onClick: this.handleClick(editorView, from, to),
      dom,
      getPosition: () => {
        const nodeDOM = editorView.nodeDOM(from);
        const {
          left: pl,
          top: pt
        } = this.$editor.getBoundingClientRect();

        if (!nodeDOM) {
          return {
            left: pl,
            top: pt
          };
        }

        const {
          left: cl,
          top: ct
        } = nodeDOM.getBoundingClientRect();
        return {
          left: cl - pl,
          top: ct - pt
        };
      }
    };
    preact.render(preact.h(Button, buttonProps), this.$popover, this.$popover.lastElementChild || undefined);
  }

}

const pluginKey = new prosemirrorState.PluginKey("dragButton");
const createPlugin = () => new prosemirrorState.Plugin({
  key: pluginKey,
  view: editorView => new View(editorView)
});

class DragButtonModule {
  constructor() {
    this.name = "dragButton";
    this.plugins = [createPlugin()];
  }

}
DragButtonModule.pluginName = "dragButton";

exports.DragButtonModule = DragButtonModule;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/dragButton/index.js